import { useTranslation } from "react-i18next";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "src/components-v2";
import { ModalProps } from "src/components-v2/Modal";
import { ModalStyled } from "./index.styled";
import TableDocs from "./TableDocs";

export default function Modal({ show, onClose }: ModalProps) {
  const { t } = useTranslation("getting-started-page");

  return (
    <ModalStyled size="huge" show={show} onClose={onClose} withoutHeader closeOnOverlay>
      <p className="custom-header u-flex u-justify-between u-font-bold u-text-lg">
        <span>{t("needed-documents.modal-title")}</span>
        <span className="u-cursor-pointer" onClick={onClose}>
          <Icon icon={faTimes} />
        </span>
      </p>
      <TableDocs className="u-mt-14" />
    </ModalStyled>
  );
}
